export default "__VITE_ASSET__c3109f9f__"